import { Component } from '@angular/core';
import {LoadingController, ModalController, NavParams, ViewController} from "ionic-angular";
import {Http} from "@angular/http";
import * as moment from 'moment';
import { Params } from '../../params';

@Component({
  selector: 'page-customer-history',
  templateUrl: 'customer-history.html',
})
export class CustomerHistoryPage {
  data = {};
  history = [];
  customerName = "";
  recurrent = false;
  out_types = Params.OUT_TYPES;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    public loadingCtrl : LoadingController,
    public http: Http
  ) {
    this.data = this.params.get("data");
    this.customerName = this.data["customer"].name+ " "+this.data["customer"].lastname;
    let loading = this.loadingCtrl.create({
      content : "Buscando historia de "+this.customerName+". Espere porfavor"
    })
    loading.present();


    this.http.post('https://us-central1-fitfood-22c23.cloudfunctions.net/customerHistory',this.data)
      .subscribe((resp)=>{
        loading.dismiss();
        this.history = resp.json();
      })
  }

  fromNow(date){
    return moment(date).fromNow();
  }

  fromDate(index){
    let startDate;
    if(index==0){
      startDate = moment(this.data['customer'].datestart)
    }else{
      startDate = moment(this.history[index-1].date)
    }
    return moment(this.history[index].date).from(startDate,true);
  }

  dateFormat(date){
    return moment(date).format("DD-MM-YYYY");
  }
  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/customer-history/customer-history.ts